var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainCom",style:(_vm.minHeight == null? '' : `height:${_vm.minHeight}px`)},[_c('VueCal',{staticClass:"vuecal--blue-theme",attrs:{"events":_vm.events,"time":false,"active-view":"month","hide-weekends":"","events-count-on-year-view":"","events-on-month-view":"short","disable-views":['years']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }